module.exports = __webpack_public_path__ + "img/about_company.eb56c6b9.png";